import { React, useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { lastYearBalance, addLastYearBalance } from '../../../store/actions/evidenceList';

import { 
    Button, 
    OverlayTrigger, 
    Tooltip,
    Modal  
} from 'react-bootstrap';

// Assets
import { ReactComponent as AddIcon } from '../../../assets/add.svg';

const LastYearBalance = ({ branchId }) => {

    const dispatch = useDispatch();

    const currentEvidenceList = useSelector(state => state.evidenceList.current);
    const id = currentEvidenceList._id;
    // Set year - 1 because we need previous year
    const year = useSelector(state => state.uiSlice.selectedYear) - 1;
    const currentYear = year + 1;

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
        if(branchId && id)
            dispatch(lastYearBalance({id, currentBranchId: branchId, year}))
    }, [id, branchId, year, dispatch]);

    const lastYear = useSelector(state => state.evidenceList.current.lastYearBalance);
    const lstYearBalance = lastYear ? lastYear.balance.toFixed(3).replace('.', ',') : 0;
    const numericLastYearBalance = lstYearBalance
        ? parseFloat(lstYearBalance.toString().replace(',', '.'))
        : 0;

    // Render Tooltips
    const renderTooltipAdd = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Pridať zostatok z minulého roka
        </Tooltip>
    );

    // Handlers
    const handleAddButtonClick = () => {
        setShowConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setShowConfirmModal(false);
    };

    const handleAddLastYearBalance = () => {
        dispatch(addLastYearBalance({id, currentBranchId: branchId, currentYear, numericLastYearBalance}));
        handleCloseConfirmModal();
    }

    return (
        <>
            <div className="centered-row">
                { lstYearBalance }
                {/* Add icon */}
                <Button
                    onClick={() => handleAddButtonClick()}
                    className="btnIcon"
                >
                    <OverlayTrigger placement="top" overlay={renderTooltipAdd}>
                        <AddIcon
                            alt="Pridať"
                            className="icon icon-add"
                        />
                    </OverlayTrigger>
                </Button>
            </div>

            {/* Confirmation modal */}
            <Modal
                show={showConfirmModal}
                onHide={handleCloseConfirmModal}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Potvrdenie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Naozaj chcete pridať zostatok z minulého roka do evidenčného listu?
                     
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirmModal}>
                        Zrušiť
                    </Button>
                    <Button variant="danger" onClick={handleAddLastYearBalance}>
                        Pridať
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default LastYearBalance;
